import { useEffect, useRef } from 'react';
import { getCustomerAccountById } from '../../infra/customerRepository';
import { useCustomerOverlayStore } from '../../store/useCustomerOverlayStore';
import { showError } from '../../../shared/ui/appToast';
import { reportUserVisibleFailure } from '../../../shared/sentry/sentryUser';
import type { useCustomerMovementFlow } from './useCustomerMovementFlow';

type MovementFlow = ReturnType<typeof useCustomerMovementFlow>;

type Params = {
  canEdit: boolean;
  openMovementModal: MovementFlow['openMovementModal'];
};

export function useCustomerCollectPane({ canEdit, openMovementModal }: Params) {
  const pendingCollectIntent = useCustomerOverlayStore((s) => s.collectIntent);
  const openMovementModalRef = useRef(openMovementModal);
  openMovementModalRef.current = openMovementModal;

  useEffect(() => {
    if (!pendingCollectIntent) return;
    const intent = useCustomerOverlayStore.getState().consumeCollectIntent();
    if (!intent) return;
    if (!canEdit) {
      showError('Modo solo lectura', 'Tu perfil no puede registrar cobros a cuenta.');
      return;
    }
    void (async () => {
      try {
        const customer = await getCustomerAccountById(intent.customerId);
        if (!customer) {
          showError('Cliente no encontrado', 'No encontramos a ese cliente.');
          return;
        }
        await openMovementModalRef.current(customer, {
          saleId: intent.saleId,
          suggestedAmount: intent.suggestedAmount,
        });
      } catch (error) {
        reportUserVisibleFailure({ module: 'customers', op: 'customer.collect_intent', error, title: 'No se pudo abrir el cobro.' });
        console.warn('[Customer] collect intent failed', error);
        showError('Error', 'No se pudo abrir el cobro.');
      }
    })();
  }, [pendingCollectIntent, canEdit]);
}
